import { render } from "./GenerateResponseSchema.vue?vue&type=template&id=a01175a4&scoped=true"
import script from "./GenerateResponseSchema.vue?vue&type=script&lang=js"
export * from "./GenerateResponseSchema.vue?vue&type=script&lang=js"

import "./GenerateResponseSchema.vue?vue&type=style&index=0&id=a01175a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a01175a4"]])

export default __exports__